
import { apiBaseURL, tenorActionType, toastifyType } from "../../constants";
import { setLoading } from "./loadingAction";
import apiConfigForIR from '../../config/apiConfigForIR'
import { addTost } from "./toastAction";
import { metaDataAction } from "./metaDataAction";


export const getTenorByCurve = (curveSlug) => async (dispatch) => {
    try {
        const response = await apiConfigForIR.get(apiBaseURL.CURVE + "/" + curveSlug + "/" + apiBaseURL.TENOR)
        dispatch({ type: tenorActionType.FETCH_TENOR, payload: response.data?.data });
        dispatch(metaDataAction({ pageNumber: response.data?.data?.currentPage || 1, pageSize: 10, totalItems: response?.data?.data?.totalRecords }))
        dispatch(setLoading(false))
    } catch (error) {
        dispatch(setLoading(false))
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}
